export function getExtension(filename) {
  var parts = filename.split(".");
  return parts[parts.length - 1];
}

export function isImage(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "jpg":
    case "gif":
    case "bmp":
    case "png":
      //etc
      return true;
  }
  return false;
}

export function isMp4(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "mp4":
      //etc
      return true;
  }
  return false;
}

export function newId() {
  let newId = String(Date.now());
  let nonce = Math.round(Math.random(0, 9));
  newId += nonce;
  return newId;
}
